module.exports = __webpack_public_path__ + "img/music.1f3592dc.png";